module.exports = __webpack_public_path__ + "img/BG-Step.f9daa9cf.svg";